module.exports = __webpack_public_path__ + "static/media/swonkieWhite.8ca63355.svg";